import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaLine } from 'react-icons/fa';
import { MdAir } from 'react-icons/md';
import { useAuth } from '../../context/AuthContext';
import styles from './PublicLayout.module.css';

const PublicHeader = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { currentUser } = useAuth();
  const adminEntryTo = currentUser ? '/admin' : '/login';

  const navLinks = [
    { to: '/', label: '首頁' },
    { to: '/products', label: '產品目錄' },
    { to: '/cases', label: '實績案例' },
    { to: '/pricing', label: '收費標準' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerInner}>
        <Link to="/" className={styles.logo}>
          <MdAir className={styles.logoIcon} />
          <span className={styles.logoText}>金順興空調工程</span>
        </Link>

        <button
          className={styles.hamburger}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="選單"
        >
          {mobileOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`${styles.nav} ${mobileOpen ? styles.navOpen : ''}`}>
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`${styles.navLink} ${isActive(link.to) ? styles.navLinkActive : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to={adminEntryTo}
            className={styles.navLinkAdmin}
            onClick={() => setMobileOpen(false)}
          >
            後台管理
          </Link>
        </nav>
      </div>
    </header>
  );
};

const PublicFooter = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.footerGrid}>
          <div className={styles.footerBrand}>
            <div className={styles.footerLogo}>
              <MdAir />
              <span>金順興空調工程</span>
            </div>
            <p className={styles.footerTagline}>專業空調安裝 · 租賃 · 維修保養</p>
            <p className={styles.footerDesc}>深耕大台灣地區超過 20 年，提供住宅、商業、展場等各類空調解決方案。</p>
          </div>

          <div className={styles.footerSection}>
            <h4>快速連結</h4>
            <ul>
              <li><Link to="/">首頁</Link></li>
              <li><Link to="/products">產品目錄</Link></li>
              <li><Link to="/cases">實績案例</Link></li>
              <li><Link to="/pricing">收費標準</Link></li>
            </ul>
          </div>

          <div className={styles.footerSection}>
            <h4>聯絡我們</h4>
            <ul className={styles.contactList}>
              <li><FaPhone /> <span>(02) 2345-6789</span></li>
              <li><FaEnvelope /> <span>service@jinshunxing.com.tw</span></li>
              <li><FaMapMarkerAlt /> <span>台北市中山區空調路100號</span></li>
            </ul>
          </div>

          <div className={styles.footerSection}>
            <h4>服務時間</h4>
            <p>週一至週五：08:00 - 18:00</p>
            <p>週六：09:00 - 17:00</p>
            <p>週日及國定假日休息</p>
            <div className={styles.socialLinks}>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebook /></a>
              <a href="https://line.me" target="_blank" rel="noreferrer" aria-label="LINE"><FaLine /></a>
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p>© {currentYear} 金順興空調工程有限公司 版權所有</p>
        </div>
      </div>
    </footer>
  );
};

const PublicLayout = ({ children }) => {
  return (
    <div className={styles.layout}>
      <PublicHeader />
      <main className={styles.main}>
        {children}
      </main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
